export default "__VITE_ASSET__CaSITkRq__"